export default __webpack_public_path__ + "static/media/mentor.c07e462a.jpeg";